import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { SopoConfirmData, SopoConfirmSettings } from '../../interfaces/confirm';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { SOPO_DIALOG_DATA, SopoDialogRef } from '../../interfaces/dialog';
import { PredictedColor } from '@soposopo/sopo-models';

export interface SopoSideBettingSuccessSettings extends SopoConfirmSettings {
    data: SopoSopoSideBettingSuccessData;
}
export interface SopoSopoSideBettingSuccessData extends SopoConfirmData {
    color: PredictedColor;
}

@Component({
    selector: 'app-sopo-side-betting-success',
    templateUrl: './sopo-side-betting-success.component.html',
    styleUrls: ['./sopo-side-betting-success.component.scss'],
    standalone: false
})
export class SopoSideBettingSuccessComponent implements OnInit, OnDestroy {
    dismissAfterTimeout: NodeJS.Timeout;
    dismissAfter: number = 3000;
    step: number = 1;
    closed: boolean = false;
    selectedAmount: number = 5;
    amounts: number[] = [5, 25, 100, 500];
    currency: string = 'golds';
    color: PredictedColor | null = null;
    sCss: string[] = [];

    constructor(
    @Inject(SOPO_DIALOG_DATA) data: SopoSopoSideBettingSuccessData,
        private renderer: Renderer2,
        private sopoDialogRef: SopoDialogRef,
    ) {
        if (data.color) this.color = data.color;
        if (data.dismissAfter) this.dismissAfter = data.dismissAfter;
        if (data.sCss) this.sCss = data.sCss;
    }

    ngOnInit() {
        if (this.dismissAfter && this.dismissAfter > 0) {
            this.dismissAfterTimeout = setTimeout(() => {
                this.cancel();
            }, this.dismissAfter);
        }
     }

    ngAfterViewInit(): void {
        this.getContainerCss();
    }

    getContainerCss() {
        const container = document.getElementsByClassName('now-opening')[0];
        if (this.sCss && this.sCss.length !== 0) {
            for (let className of this.sCss) {
                this.renderer.addClass(container, className);
            };
        }
        this.renderer.removeClass(container, 'now-opening');
    }
    cancel() {
        this.sopoDialogRef.close();
    }

    ngOnDestroy(): void {
        if (this.dismissAfterTimeout) clearTimeout(this.dismissAfterTimeout);
    }
}
